import LocationSubscriptionSerializer from './location-subscription';

export default class ScopedSubscriptionSerializer extends LocationSubscriptionSerializer {
  // Sideloaded `subscriptions` resources in `included` will also land as
  // scoped-subscription records — same trade-off as the parent.
  modelNameFromPayloadKey(payloadKey) {
    if (payloadKey === 'subscriptions') {
      return 'scoped-subscription';
    }
    return super.modelNameFromPayloadKey(...arguments);
  }

  payloadKeyFromModelName(modelName) {
    if (modelName === 'scoped-subscription') {
      return 'subscriptions';
    }
    return super.payloadKeyFromModelName(...arguments);
  }
}
